import * as React from 'react';

import {StateContext} from './StateContext';

type InfoProps = {
    questionId: number;
    onClick: any;
};

// tslint:disable-next-line function-name
export function Info(props: InfoProps): JSX.Element {
    const {state, dispatch} = React.useContext(StateContext);

    function clickHandler(): void {
        dispatch({
            type: 'TOOLTIP',
            payload: {
                questionId: props.questionId,
            },
        });
        props.onClick();
    }

    return (
        <span
            role="dialog"
            className="c-quickscan__info"
            onClick={clickHandler}
        />
    );
}
